module.exports = __webpack_public_path__ + "img/segob.c09bc46a.png";